// extracted by mini-css-extract-plugin
module.exports = {"item":"TourItem_item__AIl4A","link":"TourItem_link__gDMLi"};